(function () {
  function initializeZeroReviewState() {
    document.querySelectorAll('.product-reviews-api').forEach(function (root) {
      if (root.dataset.zeroReviewStateReady === 'true') return;

      var total = root.querySelector('.total-reviews');
      var grid = root.querySelector('.reviews-grid');
      if (!total || !grid) return;

      root.dataset.zeroReviewStateReady = 'true';

      function updateState() {
        var value = total.textContent.trim().replace(/,/g, '');
        if (!/^\d+$/.test(value)) return;

        var displayedTotal = parseInt(value, 10);
        var hasReviewCards = Boolean(
          grid.querySelector('.review-customization, [data-review-id]')
        );

        var isZeroReviewState = displayedTotal === 0 && !hasReviewCards;

        root.classList.remove('is-review-state-pending');
        root.classList.toggle('is-zero-review-state', isZeroReviewState);
        root.dataset.reviewState = isZeroReviewState ? 'zero' : 'ready';
        root.setAttribute('aria-busy', 'false');
      }

      new MutationObserver(updateState).observe(root, {
        childList: true,
        characterData: true,
        subtree: true
      });

      [0, 250, 1000, 3000].forEach(function (delay) {
        window.setTimeout(updateState, delay);
      });

      window.setTimeout(function () {
        if (root.classList.contains('is-review-state-pending')) {
          root.dataset.reviewState = 'unavailable';
          root.setAttribute('aria-busy', 'false');
        }
      }, 10000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeZeroReviewState, {
      once: true
    });
  } else {
    initializeZeroReviewState();
  }
})();
